import { getContentValues } from '@truqc/content-path';
import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';

/**
  * @function evalute - evaluate csvImportValidSelectionMappingsExistBehavior
  *
  * selectionContentPath: Path to the selected options
  *
  */ // ex: csvHeaders/*/mappedContentPath

export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions) => {
  const selectionContentPath = await evaluateSource(source.selectionContentPath, content, parentContentPath, transientContext, nativeFunctions);
  const selections = getContentValues(selectionContentPath, content);

  // if we want to run validation checks, this would be where to valdate the selections
  // could pass in the raw data to be validated, or pass in the status of a validation
  // process done elsewhere

  return !!selections.length;
};
export default {
  evaluate
};